// extracted by mini-css-extract-plugin
export var active = "_t-8";
export var addWidgetButton = "_t-9";
export var backButton = "_t-1";
export var pageContainer = "_t-2";
export var settingsContent = "_t-0";
export var sideNavContainer = "_t-6";
export var sideNavLink = "_t-7";
export var widgetContainer = "_t-5";
export var widgetSubsectionItem = "_t-3";
export var widgetSubsectionItemContent = "_t-4";